// extracted by mini-css-extract-plugin
export default {"searchControl":"GlobalSearch_searchControl__OHKuR","globalSearchIcon":"GlobalSearch_globalSearchIcon__z6BBJ"};